export default __webpack_public_path__ + "static/media/Q3-4.4acb7ad1.png";